import { useState } from 'react';
import PropTypes from 'prop-types';
import { logException, ROUTES } from 'Utils';
import PasswordField from 'Components/PasswordField';

const NewPassword = (props) => {
  const [validForm, setValidForm] = useState(false);
  const [password, setPassword] = useState('');

  const isValid = (val) => {
    // TODO: Find a better way to represent the error message below.
    const valid = props.uim.passwordRegExp.test(val);
    const isRequiredMsg = props.strings.isRequired.formatUimTranslation(
      props.strings.password
    );
    const invalidMsg = !!val.length
      ? props.strings.passwordLength
      : isRequiredMsg;
    const message = valid ? '' : invalidMsg;
    setValidForm(valid);
    return {
      valid,
      message,
    };
  };

  const setNewUserPassword = async () => {
    try {
      await props.uim.setNewPassword(props.token, password);
      props.transitionTo(ROUTES.PAGE_RESET_SUCCESS.url);
    } catch (err) {
      logException(err);
      props.failureMessage(err.message.toString());
    }
  };

  const handleChange = ({ target }) => setPassword(target.value);

  const handleSubmit = (event) => {
    event.preventDefault();
    setNewUserPassword();
  };

  return (
    <>
      <h1 className="page-heading">{props.strings.setNewPassword}</h1>
      <form onSubmit={handleSubmit} className="email-form">
        <PasswordField
          autoFocus
          className="password-input"
          hideText={props.strings.hide}
          id="password"
          isValid={isValid}
          label={props.strings.newPassword}
          onChange={handleChange}
          showText={props.strings.show}
        />
        <button type="submit" disabled={!validForm}>
          {props.strings.confirm}
        </button>
      </form>
    </>
  );
};

NewPassword.propTypes = {
  failureMessage: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  transitionTo: PropTypes.func.isRequired,
  uim: PropTypes.object.isRequired,
};

export default NewPassword;
